import { mcfSeoMetaData } from './mcf.seo'
import { authRepSeoMetaData } from './authorized-representative.seo'
import { claimsSeoMetaData } from './claims.seo'
import { msaSeoMetaData } from './msa.seo'
import { mspSeoMetaData } from './msp.seo'
import { eMSNSeoMetaData } from './emsn.seo'
import { fallbackSeoMetaData } from './fallback.seo'
import { preferencesSeoMetaData } from './preferences.seo'
import { SiteActivityComponent } from 'models/activity'
import { accountSettingsSeoMetaData } from './account-settings.seo'
import { preventiveServicesSeoMetaData } from './preventive-services.seo'
import { accountHomeSeoMetaData } from './account-home.seo'

export interface ISeoMetaData {
  /**
   * Use Regex for wildcard matches. Strings will be matched exactly
   */
  path: string | RegExp,
  blastPageName?: string,
  isQmMaskingEnabled?: boolean,
  component: SiteActivityComponent
  seo: {
    en: {
      title?: string
      description?: string
    },
    es: {
      title?: string
      description?: string
    }
  }
}

export const seoMetaData = mcfSeoMetaData
  .concat(accountSettingsSeoMetaData)
  .concat(authRepSeoMetaData)
  .concat(claimsSeoMetaData)
  .concat(msaSeoMetaData)
  .concat(mspSeoMetaData)
  .concat(eMSNSeoMetaData)
  .concat(preferencesSeoMetaData)
  .concat(preventiveServicesSeoMetaData)
  .concat(accountHomeSeoMetaData)
  // Fallback uses a non-exact match over the entire app. It needs concatenated last
  .concat(fallbackSeoMetaData)
